import { z } from 'zod';

export const CreateWithdrawResultSchema = z.object({
  id: z.string(),
  status: z.string(),
  account_id: z.string(),
  bank_account_id: z.string(),
  payment_network: z.string(),
  currency: z.string(),
  amount: z.number(),
});

export type CreateWithdrawResult = z.infer<typeof CreateWithdrawResultSchema>;

export interface CreateWithdrawParams {
  amount: string;
  currency: string;
  payment_network: string;
  account_id: string;
  google_code: string;
}
